import { useScale } from '../../../hooks/useScale';
import theme from '../../../common/theme';
import { StyleSheet } from 'react-native';

const ModalTitleStyles = () => {
  const { scale } = useScale();
  const fgColor = theme.colors.black;

  return StyleSheet.create({
    container: {
      height: scale(44),
      alignItems: 'center',
      flexDirection: 'row',
      borderRadius: theme.radius.s,
      backgroundColor: theme.colors.white,
    },
    btnClose: {
      width: scale(44),
      height: scale(44),
      alignItems: 'center',
      justifyContent: 'center',
    },
    title: {
      flex: 1,
      marginRight: scale(44),
      textAlign: 'center',
      fontFamily: theme.fonts.medium,
      color: fgColor,
    },
    icon: {
      color: fgColor,
    },
  });
};

export default ModalTitleStyles;
